/**
 * Created by jiachenpan on 16/11/18.
 */

export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") {
      return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    }
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatTime(time, option) {
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return "刚刚";
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + "分钟前";
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + "小时前";
  } else if (diff < 3600 * 24 * 2) {
    return "1天前";
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return (
      d.getMonth() +
      1 +
      "月" +
      d.getDate() +
      "日" +
      d.getHours() +
      "时" +
      d.getMinutes() +
      "分"
    );
  }
}
/**
 *  时间格式化显示
 * @param {*} d 时间
 * @param {*} fmt 格式
 */
export function format(d, fmt) {
  const t = new Date(d);
  const o = {
    "Y+": t.getFullYear(), // 年
    "M+": t.getMonth() + 1, // 月份
    "D+": t.getDate(), // 日
    "H+": t.getHours(), // 小时
    "m+": t.getMinutes(), // 分
    "s+": t.getSeconds(), // 秒
    "q+": Math.floor((t.getMonth() + 3) / 3), // 季度
    "S+": t.getMilliseconds(), // 毫秒
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (t.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}
/**
 *  格式化时间为YYYY-MM-DD HH:mm
 * @param {*} d 时间
 */
export function formatDateTime(d, s) {
  let fmt = "YYYY-MM-DD HH:mm";
  if (s) {
    fmt = s;
  }
  const t = new Date(d);
  const o = {
    "Y+": t.getFullYear(), // 年
    "M+": t.getMonth() + 1, // 月份
    "D+": t.getDate(), // 日
    "H+": t.getHours(), // 小时
    "m+": t.getMinutes(), // 分
    "s+": t.getSeconds(), // 秒
    "q+": Math.floor((t.getMonth() + 3) / 3), // 季度
    "S+": t.getMilliseconds(), // 毫秒
  };
  if (/(Y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (t.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

export function formatSeconds(seconds) {
  const date = new Date(seconds * 1000); // 将秒数转换为毫秒数
  const hours = date.getUTCHours();
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");
  const secs = String(date.getUTCSeconds()).padStart(2, "0");

  if (hours > 0) {
    return `${String(hours).padStart(2, "0")}:${minutes}:${secs}`;
  } else {
    return `${minutes}:${secs}`;
  }
}

/**
 * 防抖动
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
export function debounce(func, wait, immediate) {
  let timeout, args, context, timestamp, result;

  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function (...args) {
    context = this;
    timestamp = +new Date();
    const callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

export const bestThrottle = (fn, delay) => {
  // last为上一次触发回调的时间, timer是定时器
  var last = 0;
  var timer = null;
  // 将throttle处理结果当作函数返回
  return function () {
    // 保留调用时的this上下文
    const context = this;
    // 保留调用时传入的参数
    /* eslint-disable */
    const args = arguments;
    /* eslint-enable */
    // 记录本次触发回调的时间
    const now = Date.now();
    // 判断上次触发的时间和本次触发的时间差是否小于时间间隔的阈值
    if (now - last < delay) {
      // 如果时间间隔小于我们设定的时间间隔阈值，则为本次触发操作设立一个新的定时器
      clearTimeout(timer);
      timer = setTimeout(() => {
        last = now;
        fn.apply(context, args);
      }, delay);
    } else {
      // 如果时间间隔超出了我们设定的时间间隔阈值，那就不等了，无论如何要反馈给用户一次响应
      last = now;
      fn.apply(context, args);
    }
  };
};

export function deepCopy(origin, map = new Map()) {
  if (origin && typeof origin === "object") {
    const copy = Array.isArray(origin) ? [] : {};
    if (map.has(origin)) {
      return map.get(origin);
    }
    map.set(origin, copy);
    Object.keys(origin).forEach((key) => {
      copy[key] = deepCopy(origin[key], map);
    });
    return copy;
  } else {
    return origin;
  }
}

export function getSingle(func) {
  let instance = null;
  return function (...args) {
    return instance || (instance = func.apply(this, args));
  };
}

// 检查图片大小
export function asyncImgChecked(file, w, h) {
  return new Promise((resolve) => {
    let reader = new FileReader();
    reader.readAsDataURL(file.raw); // 必须用file.raw
    reader.onload = () => {
      // 让页面中的img标签的src指向读取的路径
      let img = new Image();
      img.src = reader.result;
      if (img.complete) {
        // 如果存在浏览器缓存中
        if (img.width > w || img.height > h) {
          resolve(false);
        } else {
          resolve(true);
        }
      } else {
        img.onload = () => {
          if (img.width > w || img.height > h) {
            resolve(false);
          } else {
            resolve(true);
          }
        };
      }
    };
  });
}

// 复制到剪切板
export function copyToClipboard(text) {
  const input = document.createElement("input");
  input.value = text;
  document.body.appendChild(input);
  input.select();
  document.execCommand("copy");
  document.body.removeChild(input);
}

function doubleClick() {
  let bool = true;
  return function (fn, time = 1000) {
    if (bool) {
      fn();
      bool = false;
      setTimeout(() => {
        bool = true;
      }, time);
    }
  };
}

export const onceClick = doubleClick();
